<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">
    <loading :active.sync="loading" :is-full-page="fullPage"/>
    <notifications group="error" :width="500" :duration="5000" position="top center"/>
    <notifications group="info" :width="500" :duration="5000" position="top center"/>
    <transition name="fade"
                mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>
<script>
  import('sweetalert2/dist/sweetalert2.css')
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';

  export default {
    name: 'app',
    data () {
      return {
        title: 'POS admin portal',
        fullPage: true
      }
    },
    computed: {
      loading () {
        return this.$store.getters.getLoading
      },
      error () {
        return this.$store.getters.getError
      }
    },
    watch: {
      error() {
        if (this.$store.getters.getError !== null) {
          let errors = this.$store.getters.getError;
          if (Array.isArray(errors)) {
            errors.forEach(e => {
              let msg = e.message;
              if(this.$t("error." + e.code)) {
                msg = this.$t("error." + e.code);
              }
              this.$notify({
                group: "error",
                title: this.$t("error.title"),
                type: "error",
                text: msg,
              });
            });
          } else {
            this.$notify({
              group: "error",
              title: this.$t("error.title"),
              type: "error",
              text: errors
            });
          }
        }
        this.$store.commit("clearError");
      }
    },
    components: {
      Loading
    }
  }
</script>

<style>
  /*@import "https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css";*/
  @import "https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css";
  @import "https://cdn.jsdelivr.net/themify-icons/0.1.2/css/themify-icons.css";
  /*@import "~frontend_common/src/assets/css/themify-icons.css";*/
</style>
